export enum Language {
    ENGLISH = 'en',
    ARABIC = 'ar',
    ENGLISH_CANADIAN = 'en-ca',
    FRENCH = 'fr',
    SPANISH = 'es',
    HMONG = 'hmn',
    KARABORO = 'kar',
    KOREAN = 'ko',
    OROMO = 'om',
    RUSSIAN = 'ru',
    SOMALI = 'so',
    VIETNAMESE = 'vi',
    CHINESE_SIMPLIFIED = 'zh-hans',
    CHINESE_TRADITIONAL = 'zh-hant',
}

export namespace Language {
  export function fromLocale(locale: string): Language | undefined {
    const language = Object
      .entries(Language)
      .find(([, value]) => value === locale)
      ?.[0] as Language

    return language;
  }

  export function valueOf(str: string): Language | undefined {
    const enumKey = Language[str];
    return enumKey;
  }
}